type AdminMetadata = {
	admin?: unknown;
};

type MaybeUser = {
	publicMetadata?: AdminMetadata;
	privateMetadata?: AdminMetadata;
	unsafeMetadata?: AdminMetadata;
	role?: unknown;
} | null;

export const isSuperAdminFlag = (value: unknown): boolean => {
	if (value === true) {
		return true;
	}

	if (typeof value === "string") {
		const normalized = value.trim().toLowerCase();
		return normalized === "true" || normalized === "1" || normalized === "yes";
	}

	return value === 1;
};

export const isSuperAdminRole = (role: unknown): boolean => {
	const isAdminLikeRole = (candidate: unknown) => {
		if (typeof candidate !== "string") {
			return false;
		}

		const normalized = candidate.trim().toLowerCase().replaceAll("-", "_");
		return (
			normalized === "super_admin" ||
			normalized === "superadmin" ||
			normalized === "admin"
		);
	};

	if (Array.isArray(role)) {
		return role.some((candidate) => isAdminLikeRole(candidate));
	}

	return isAdminLikeRole(role);
};

export const isSuperAdminUser = (user: MaybeUser): boolean =>
	isSuperAdminRole(user?.role) ||
	isSuperAdminFlag(user?.publicMetadata?.admin) ||
	isSuperAdminFlag(user?.privateMetadata?.admin) ||
	isSuperAdminFlag(user?.unsafeMetadata?.admin);
